<template>
  <simple-scrollable-modal class="new-order-modal add-order-item-modal">
    <template #title>
      <h4>Agregar item</h4>
    </template>
    <template #content>
      <div class="order-item-container" v-if="selectedItem || loadingItem">
        <v-skeleton-loader type="paragraph" v-if="loadingItem" />
        <template v-else>
          <add-item-widget
            :item="selectedItem"
            :final-options="selectedItem.options"
            :restaurant="restaurant"
            :edit="edit"
            :currency="currency"
            :restaurant-settings="restaurantSettings"
            @change="onOrderItemChanged"
            @on-validation="valid = $event"
          />
        </template>
      </div>
    </template>
    <template #action-bar>
      <div class="d-flex flex-row align-center justify-space-between">
        <v-btn class="" depressed @click="$emit('close')"> Cancelar </v-btn>
        <div v-if="orderItem" class="flex-fill text-right">
          <vue-numeric-input
            v-model="orderItem.amount"
            class="counter"
            :min="1"
            :max="50"
          />
          <v-btn
            class="add-button ml-2"
            color="primary"
            depressed
            @click="add"
            :disabled="!valid"
          >
            <span class="preview-price"
              >{{ currency.symbol }}{{ orderItem.total }}</span
            >
            {{ !edit ? 'Agregar' : 'Guardar' }}
          </v-btn>
        </div>
      </div>
    </template>
  </simple-scrollable-modal>
</template>

<script lang="ts">
  import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
  import { IItem } from '../../../interfaces/IItem';
  import { IItemSearchResumed } from '../../../interfaces/IItemSearchResumed';
  import { IRestaurant } from '../../../interfaces/IRestaurant';
  import { IBranch } from '../../../interfaces/IBranch';
  import { ICurrency } from '../../../interfaces/ICurrency';
  import { IRestaurantSettings } from '../../../api/services/restaurants.service';
  import { Globals } from '../../../modules/Globals';
  import { debounce } from '../../../utils';
  import ItemsService from '../../../api/services/items.service';
  import AddItemWidget from '../../widgets/AddItemWidget.vue';
  import SimpleScrollableModal from '../base/SimpleScrollableModal.vue';
  import { IOrderItem } from '../../../interfaces/IOrderItem';
  import VueNumericInput from 'vue-numeric-input';
  import ItemOption from '../../widgets/ItemOption.vue';
  import { vueData } from '../../../VueData';
  import { IOption } from '../../../interfaces/IOption';
  import { cloneDeep } from 'lodash';

  @Component({
    components: { SimpleScrollableModal, AddItemWidget, VueNumericInput },
  })
  export default class AddItemModal extends Vue {
    @Prop() restaurant: IRestaurant;
    @Prop() branch: IBranch;
    @Prop() currency: ICurrency;
    @Prop() restaurantSettings: IRestaurantSettings;
    @Prop() edit: IOrderItem;
    @Prop() itemId?: number;
    @Prop() fullItem: IItem;
    itemsService = new ItemsService();
    uploadsPath = Globals.uploadsPath;
    loadingItem: boolean = false;
    selectedItem: IItem = null;
    orderItem: IOrderItem = null;
    valid: boolean = false;

    async created() {
      if (this.fullItem) {
        this.selectedItem = cloneDeep(this.fullItem);
      } else if (this.edit) await this.loadItem(this.edit.itemId);
      else if (this.itemId) await this.loadItem(this.itemId);
    }

    mounted() {}

    onOrderItemChanged(orderItem: IOrderItem) {
      this.orderItem = orderItem;
    }

    @Watch('orderItem')
    onOrderItemChange() {
      if (
        !this.edit &&
        !this.selectedItem.options.length &&
        !this.selectedItem.priceVariants &&
        this.valid
      ) {
        Vue.nextTick(() => this.add());
      }
    }

    async loadItem(id: number) {
      this.selectedItem = null;

      try {
        this.loadingItem = true;
        let item: IItem, options: IOption[];
        const loadItem = async () =>
          (item = await this.itemsService.getById(id));
        const loadOptions = async () =>
          (options = await ItemsService.getFinalOptions(id));
        await Promise.all([loadItem(), loadOptions()]);
        item.options = options;

        this.selectedItem = item;
      } catch (e) {
        vueData.serverError(e);
        console.error(e);
      } finally {
        this.loadingItem = false;
      }
    }

    add() {
      this.$parent.$emit('add', this.orderItem);
      this.$emit('close');
    }
  }
</script>
